export default __webpack_public_path__ + "static/lofi2-93197f240223f71b1e1f87534852e590.png";